// @flow

import * as React from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../store/Calculation";
import ReactAI from 'react-appinsights';
import type {ProjectUiInput} from "../store/Calculation";
import type {AuthSummary} from "../common/RequestTypes";

type Props = {
    personEmail: string,
    projectUiInput: ProjectUiInput,
    authSummary: AuthSummary[]
};

type State = {
}

class Logout extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
    }

    componentWillMount() {
    }

    render() {
        const authSummary = this.props.authSummary && this.props.authSummary.length && this.props.authSummary[0];
        return authSummary ? (<div className="logout">
            <p>Du är inloggad som <i>{authSummary.userRealName} ( {authSummary.userEmail} )</i></p>
            <p><a href="/.auth/logout?post_logout_redirect_uri=/login">Logga ut</a></p>
        </div>) : (<div className="logout">
            <p>Du är inte inloggad</p>
        </div>)
    };
}

export default ReactAI.withTracking(connect(
    state => state.calculation,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Logout));





// WEBPACK FOOTER //
// ./src/components/Logout.js